export default __webpack_public_path__ + "static/media/Mental-health-bg.e47ab212.svg";